/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useI18next } from "gatsby-plugin-react-i18next"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"

function SEO({ description, lang, meta, title, module_name, page_name }) {
  const { language } = useI18next()
  const { site, allSettings } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
        allSettings {
          nodes {
            seo {
              items {
                meta_description
                meta_title
              }
              module_name
              page_name
            }
            lang
          }
        }
      }
    `
  )

  const { seo } = allSettings.nodes.find(d => d.lang === language)
  const flatterdSeo = seo.length > 0 ? seo.reduce((acc, val) => {
    if (Array.isArray(val)) {
      acc = [...acc, ...val]
    } else {
      acc = [...acc, val]
    }
    return acc
  }, []) : [];
  const data = flatterdSeo.find(
    d => d.module_name === module_name && d.page_name === page_name
  )

  const metaDescription = data
    ? data.items.meta_description
    : description || site.siteMetadata.description

  const metaTitle = data ? data.items.meta_title : title

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={metaTitle}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: metaTitle,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: metaDescription,
        },
        {
          name: `twitter:title`,
          content: metaTitle,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
      ].concat(meta)}
    />
  )
}

SEO.defaultProps = {
  lang: `id`,
  meta: [],
  description: ``,
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
}

export default SEO
